import { render, staticRenderFns } from "./LuCity.vue?vue&type=template&id=6f04596c&"
import script from "./LuCity.vue?vue&type=script&lang=js&"
export * from "./LuCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports